import { useQuery } from "@tanstack/react-query";
import { Button, Card, Descriptions, Flex, Table, Tag, Typography } from "antd";
import { useNavigate, useParams } from "react-router";
import { customerService } from "../../../services/customer.service";
import { useTableHeight } from "../../../hooks/useTableHeight";

export default function UserManagementDetail() {

  const navigate = useNavigate()

  const tableHeight = useTableHeight();

  const { id } = useParams()

  const { data: customerData } = useQuery({
    queryKey: ['customerData', id],
    queryFn: () => customerService.getById(id),
    enabled: !!id,
    select: (res) => res.data
  })

  return (
    <>
      <Card
        title="Informasi Pelanggan"
      >
        {/* <Descriptions
          size="small"
          bordered
          column={2}
          layout="horizontal"
          styles={{ label: { width: 120 } }}
          items={[
            {
              label: "Status",
              children: customerData?.status ? <Tag color="green" >Aktif</Tag> : <Tag color="red" >Non Aktif</Tag>,
              span: 2
            },
            {
              label: "Waktu Verifikasi",
              children: customerData?.status ? <Tag color="green" >Aktif</Tag> : <Tag color="red" >Non Aktif</Tag>,
              span: 2
            },
          ]}
        /> */}
        <Descriptions
          size="small"
          bordered
          column={2}
          layout="horizontal"
          styles={{ label: { width: 150 } }}
          items={[
            {
              label: "Nama Lengkap",
              children: customerData?.name,
              span: 2
            },
            {
              label: "No Handphone",
              children: customerData?.phone,
              styles: { content: { width: 150 } }
            },
            {
              label: "Email",
              children: customerData?.email,
            },
            {
              label: "Status",
              children: customerData?.status ? <Tag color="green" >Aktif</Tag> : <Tag color="red" >Non Aktif</Tag>,
              styles: { content: { width: 150 } }
            },
            {
              label: "Waktu Verifikasi",
              children: customerData?.verifiedAt,
            },
          ]}
        />
      </Card>
      <Card
        title="Informasi Nomen"
        style={{ marginTop: 20 }}
      >
        <Table
          size="small"
          pagination={false}
          rowKey={'id'}
          dataSource={customerData?.nomen}
          scroll={{ y: tableHeight }}
          columns={[
            {
              title: 'Nomen',
              dataIndex: 'nomen',
              fixed: 'left',
              width: 160,
              render: (val, record) => (
                <Typography>
                  {val} {record.isDefault && <Tag style={{ marginLeft: 10 }} color="cyan" >Utama</Tag>}
                </Typography>
              )
            },
            {
              title: 'Area',
              dataIndex: 'area',
              width: 120
            },
            {
              title: 'Rayon',
              dataIndex: 'rayon',
              width: 120
            },
            {
              title: 'Area Bisnis',
              dataIndex: 'ab',
              width: 120
            },
            {
              title: 'Alamat',
              dataIndex: 'address',
              width: 320
            },
            // {
            //   // title: 'Utama',
            //   dataIndex: 'isDefault',
            //   render: val => val && <Tag>Utama</Tag>,
            //   width: 320
            // },
          ]}
        // expandable={{
        //   expandedRowRender: (record) => (
        //     <Table
        //       size="small"
        //       dataSource={[record]}
        //       pagination={false}
        //       columns={[
        //         {
        //           title: 'Area',
        //           dataIndex: 'area'
        //         },
        //         {
        //           title: 'Rayon',
        //           dataIndex: 'rayon'
        //         },
        //         {
        //           title: 'Area Bisnis',
        //           dataIndex: 'ab'
        //         },
        //         {
        //           title: 'Alamat',
        //           dataIndex: 'address'
        //         },
        //       ]}
        //     />
        //   )
        // }}
        />
      </Card>
      <Flex justify="flex-end" style={{ marginTop: 20 }} >
        <Button onClick={() => navigate('/user-management')} variant="outlined" color="primary" style={{ backgroundColor: 'transparent' }} >
          Kembali
        </Button>
      </Flex>
    </>
  )
}